import { getClientCustomFetch } from '../lib/getClientCustomFetch'

const userLogin = async data => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/login', data, { headers: { excludeAuth: true } })
  return response?.data?.customer
}

const registerUser = async data => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/register', data, { headers: { excludeAuth: true } })
  return response
}

const resetPassword = async data => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/password', data, { headers: { excludeAuth: true } })
  return response
}

const sendOTP = async data => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/otp', data, { headers: { excludeAuth: true } })
  return response
}

const verifyEmail = async data => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/customer-verification', data, { headers: { excludeAuth: true } })
  return response
}

export { userLogin, registerUser, resetPassword, sendOTP, verifyEmail }
